/** 物品分类 */
export const ArticleCategory = {
    CATEGORY: 'CATEGORY',
    PRICE: 'PRICE',
    WEIGHT: 'WEIGHT',
    HELP_BUG_REMAEK: 'HELP_BUG_REMAEK'
};

export const GoodsTagTypeEnum = [{ "code": "CATEGORY", "value": "品类" }, { "code": "PRICE", "value": "价值" }, { "code": "WEIGHT", "value": "重量" }, { "code": "HELP_BUG_REMAEK", "value": "帮我买备注" }];

